import React, { useRef, useState } from 'react';
import {
    Paper,
    Typography,
    Grid,
    Button,
    Container, CircularProgress, InputAdornment, useTheme
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './SinginStyles';
import { Copyright } from '../../../dashboard/componet/UI/CopyRight';
import { postLogin, selectLoading, selectPayload } from '../../domain/userSlice';
import { EMAIL } from '../../../app/api-client/constants';

export default function SinginForm(props) {

    const { register, formState: { errors }, handleSubmit } = useForm();
    const classes = useStyles();
    const borderRadius = clsx(classes.padding, classes.borderRadius);
    const dispatch = useDispatch();
    const passwordInputRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);

    const isLoading = useSelector(selectLoading);
    const payload = useSelector(selectPayload);
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    const handleForgotPassword = () => {
        if (props.onForgotPassword) {
            props.onForgotPassword();
        }
    };


    const onSubmit = (data) => {
        localStorage.setItem(EMAIL, data.email);
        dispatch(postLogin({
            usernameOrEmail: data.email,
            password: data.password
        }))
    }
    const inputStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
        height:'19px'

    };
    const inputStylespass = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
        paddingRight: '40px',
        height:'19px',
        width:'220px'
    };

    return (

        <div className={classes.centerv} >
            <Container maxWidth="xs" alignitems="center"  >
                <Paper className={borderRadius}>
                    <div className={classes.margin}>
                        <Grid container justifyContent="center" style={{ marginTop: '15px' }}>
                            <img src='https://orus-centraldevida.s3.amazonaws.com/Logos/EVBI+-+Logo__3.png' width="300" alt="Logo" />
                        </Grid>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={8} alignItems="flex-end" style={{ marginTop: '15px' }}>
                                <Grid item>

                                </Grid>

                                <Grid item md={true} sm={true} xs={true} style={{ padding: '32px 32px 32px 0px' }}>
                                    <input
                                        placeholder="E-mail"
                                        name="email"
                                        type="text"
                                        style={inputStyles}
                                        {...register('email', {
                                            required: "E-mail Address is required.",
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Entered value does not match email format"
                                            }
                                        })}
                                    />
                                    {errors.email && (
                                        <Typography variant="body2" color="error" style={{ position: 'absolute', top: '100%', left: 0 }}>
                                            {errors.email.message}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container spacing={8} alignItems="flex-end">
                                <Grid item>

                                </Grid>
                                <Grid item md={true} sm={true} xs={true} style={{ padding: '32px 32px 32px 0px' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Contraseña"
                                        name="password"
                                        style={inputStylespass}
                                        ref={passwordInputRef}
                                        {...register('password', {
                                            required: "Contraseña requerida."
                                        })}
                                        className={classes.passwordInput}
                                    />
                                    {errors.password && (
                                        <Typography variant="body2" color="error" style={{ position: 'absolute', top: '100%', left: 0 }}>
                                            {errors.password.message}
                                        </Typography>
                                    )}
                                    <InputAdornment position="end" style={{ cursor: 'pointer', marginBottom: '7px' }} onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <VisibilityIcon style={{ color: primaryColor }} /> : <VisibilityOffIcon style={{ color: primaryColor }} />}
                                    </InputAdornment>
                                </Grid>

                            </Grid>
                            <Grid container justifyContent="space-between" alignItems="flex-end" style={{ marginTop: '10px', marginLeft: '35px' }}>
                                <Grid item >
                                    <Button
                                        disableFocusRipple
                                        disableRipple
                                        style={{ textTransform: "none" }}
                                        variant="text"
                                        color="primary"
                                        onClick={handleForgotPassword}
                                    >
                                        ¿Olvidaste tu contraseña?
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.wrapper}>
                                <Grid container justifyContent="center" style={{ marginTop: '20px', width: "50%", marginLeft: '25%' }}>
                                    <Button
                                        disabled={isLoading}
                                        type="submit"
                                        variant="contained"
                                        style={{ textTransform: "none", width: "inherit", color: "white", backgroundColor: primaryColor }}
                                    >
                                        Ingresar
                                    </Button>
                                </Grid>
                                {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                            {payload.error && <Alert severity="error">Usuario o Contraseña no son Validos</Alert>}


                        </form>
                    </div>
                    <Copyright />
                </Paper>
            </Container >
        </div>

    );

}
